class oCheckout extends HTMLDivElement {
    /**
     * @listens mAddressSelectorCard#change
     * @listens mAddressSelectorCard#savecardedition
     */
    constructor() {
        super();

        this.shippingForm = document.getElementById('shipping-form');
        this.shippingForm?.addEventListener('checkout:formError', this.onShippingFormError.bind(this));

        this.currentStage = document.getElementById('checkout-main')?.dataset?.checkoutStage || 'customer';
        this.onStageChange = this.onStageChange.bind(this);
        document.addEventListener('checkout:stageChange', this.onStageChange);

        document.addEventListener('checkout:customerChange', (event) => {
            this.updateShippingEmail(event.detail.email);
        });

        // Address selection handling
        this.addressSelectors = [...this.querySelectorAll('[is="m-address-selector"]')];
        this.addressSelectEls = [...this.querySelectorAll('select.address-selector')];

        // Setup m-address-selector events
        this.addressSelectors.forEach((selectorEmitter) => {
            selectorEmitter.addEventListener('change', this.onAddressSelectorChange.bind(this));
            selectorEmitter.addEventListener('savecardedition', this.onAddressSelectorSaveCard.bind(this));
        });

        // Setup <select> address-selector events
        this.addressSelectEls.forEach((selectEl) => {
            selectEl.addEventListener('change', this.onAddressSelectChange.bind(this));
        });

        this.updateCustomerStageTitle();
    }

    onStageChange(event) {
        this.currentStage = event.detail.stage;
        window.scrollTo(0, 0); // Scroll to top when step changes
        this.updateCustomerStageTitle();
    }

    /*
     * Update step title block of customerModify
     * TODO should be done elsewhere, maybe a molecule on this block?
     */
    updateCustomerStageTitle() {
        const stepTitleBlock = this.querySelector('.customer-details-summary .step-title-block');

        if (!stepTitleBlock) {
            return;
        }

        stepTitleBlock.classList.remove('previous-step', 'current-step');
        if (this.currentStage === 'customerModify') {
            stepTitleBlock.classList.add('current-step');
        } else {
            stepTitleBlock.classList.add('previous-step');
        }
    }

    /**
     * Update shipping email field according to new customer email
     * @param {string} newEmail New customer email
     */
    // eslint-disable-next-line class-methods-use-this
    updateShippingEmail(newEmail) {
        const emailInput = document.getElementById('shippingEmail');
        emailInput.value = newEmail;
        this.shippingForm.setActiveInput(emailInput);
        this.shippingForm.triggerCheckEvent(emailInput, false);
    }

    /**
     * Update address hidden <select> on m-address-selector `change` event
     * @param {CustomEvent} event Event `change` object from a m-address-selector
     */
    onAddressSelectorChange(event) {
        if (event.currentTarget !== event.target) {
            // Filter out change event from other elements
            return;
        }
        const selectorEl = event.target;
        const { addressId } = event.detail;

        // Setup address selector <select>
        this.addressSelectEls.forEach((selectEl) => {
            if (
                selectEl.form
                && selectEl.form !== document.getElementById(selectorEl.dataset.formId)
            ) {
                // Don't change <select> different from the current targetted form
                return;
            }
            const optionEl = selectEl.querySelector(`option[data-address-id="${addressId}"]`);
            selectEl.value = optionEl.value;
            selectEl.dispatchEvent(new Event('change'));
        });
    }

    /**
     * Update address hidden <select> <option> on m-address-selector `savecardedition` event
     * @param {CustomEvent} event Event `savecardedition` object from a m-address-selector
     */
    onAddressSelectorSaveCard(event) {
        const card = event.target;
        const { oldAddressId, newAddressId, templates } = event.detail;

        // Update address card selector
        this.addressSelectors.forEach((selector) => {
            if (selector === event.currentTarget) {
                return;
            }

            if (card.dataset.mode === 'addition') {
                selector.addNewAddressCard(event.detail.templates.addressSelectorCard);
            } else {
                selector.updateAddressCard(
                    oldAddressId,
                    newAddressId,
                    templates?.addressSelectorCardSummary,
                );
            }
        });

        // Replace/Add <option> in address selectors <select>
        this.addressSelectEls.forEach((selectEl) => {
            const tmpEl = document.createElement('div');
            tmpEl.innerHTML = templates?.shipmentSelectorOption;
            const newOptionEl = tmpEl.querySelector('option');
            const oldOptionEl = oldAddressId ? selectEl.querySelector(`option[data-address-id="${oldAddressId}"]`) : null;
            newOptionEl.toggleAttribute('selected', oldOptionEl?.selected ?? false);
            if (oldOptionEl) {
                oldOptionEl.replaceWith(newOptionEl);
            } else {
                selectEl.append(newOptionEl);
            }
        });
    }

    /**
     * Update (hidden) address shipping/billing form on hidden address <select> change
     * @param {Event} event Event object from a HTMLSelectElement
     */
    // eslint-disable-next-line class-methods-use-this
    onAddressSelectChange(event) {
        const selectEl = event.target;
        const optionEl = selectEl.selectedOptions[0];
        const addressForm = selectEl.form;
        if (!addressForm) {
            // eslint-disable-next-line no-console
            console.error('Form not found ; No address form will be updated');
            return;
        }
        const addressFields = optionEl.dataset;
        Object.keys(addressFields).forEach((fieldKey) => {
            const name = fieldKey === 'countryCode' ? 'country' : fieldKey;
            const inputEl = addressForm.querySelector(`[name$=${name}]`);
            if (inputEl) {
                inputEl.value = addressFields[fieldKey];
                if (inputEl.type === 'select-one') {
                    if (fieldKey === 'stateCode') {
                        inputEl.dataset.stateValue = addressFields[fieldKey];
                    }
                    inputEl.value = addressFields[fieldKey];
                    inputEl.dispatchEvent(new Event('change'));
                }
                if (fieldKey === 'phone') {
                    const phoneField = addressForm.querySelector('[id$="-form-phone"], [id$="-register-phonenr"]');
                    // Get instance of intl-tel-input to manage phone field:
                    const iti = window.intlTelInputGlobals.getInstance(phoneField);
                    if (iti) {
                        iti.setNumber(addressFields[fieldKey]);
                    }
                }
            }
        });
    }

    /**
     * Updates on shipping form error
     * TODO: find a better way to handle address registered containing errors
     */
    onShippingFormError() {
        // If an address is selected inside the address selector, set it to edition view
        this.addressSelectors.forEach((selector) => {
            const selectedCard = selector.querySelector('[is="m-address-selector-card"].selected');
            selectedCard?.setEditionView();
        });
    }
}

customElements.define('o-checkout', oCheckout, {
    extends: 'div',
});
